export function purchaseReducer(state = {
    PURCHASES : {},
    REAPPRO : {},
    ALL : {},
},{
    type,
    payload
}){
    
    switch(type){
        case "NEW_PURCHASE": 
            return {
                ...state,
                ALL: {
                    [payload.id]: payload,
                    ...state.ALL
                },
                PURCHASES: {
                    [payload.id]: payload,
                    ...state.PURCHASES
                }
            };
        case "UPDATE_PURCHASE": 
            return {
                ...state,
                ALL: {
                    ...state.ALL,
                    [payload.id]: payload
                },
                PURCHASES: {
                    ...state.PURCHASES,
                    [payload.id]: payload
                }
            };
            
        case "NEW_PURCHASE_REAPPRO":  
            return {
                ...state,
                ALL: {
                    [payload.id]: payload,
                    ...state.ALL
                },
                REAPPRO: {
                    [payload.id]: payload,
                    ...state.REAPPRO
                }
            };
        case "UPDATE_PURCHASE_REAPPRO": 
            return {
                ...state,
                ALL: {
                    ...state.ALL,
                    [payload.id]: payload
                },
                REAPPRO: {
                    ...state.REAPPRO,
                    [payload.id]: payload
                }
            };

        case "GET_PURCHASES":        
            return payload;
        
        case "DELETE_PURCHASE":
            const { [payload]: deletedFromAll, ...newAll } = state.ALL;
            const { [payload]: deletedFromPurchases, ...newPurchases } = state.PURCHASES;
            const { [payload]: deletedFromReappro, ...newReappro } = state.REAPPRO;
            
            return {
                ...state,
                ALL: newAll,
                PURCHASES: newPurchases,
                REAPPRO: newReappro
            };

        case "UPDATE_PURCHASES_LINK":
            console.log('====================================');
            console.log({payload});
            console.log('====================================');

            const updatedAllLink = { ...state.ALL };
            const updatedPurchasesLink = { ...state.PURCHASES };
            
            payload.list.forEach( ID => {
                if (updatedAllLink[ID] && updatedAllLink[ID].fact_id_5000) {
                    let newStr = updatedAllLink[ID].fact_id_5000 + ", " + payload.spending_id
                    
                    updatedAllLink[ID] = {
                        ...updatedAllLink[ID],
                        fact_id_5000: newStr
                    };
                    updatedPurchasesLink[ID] = {
                        ...updatedPurchasesLink[ID],
                        fact_id_5000: newStr
                    };
                } else if (updatedAllLink[ID]) {
                    updatedAllLink[ID] = {
                        ...updatedAllLink[ID],
                        fact_id_5000: payload.spending_id
                    };
                    updatedPurchasesLink[ID] = {
                        ...updatedPurchasesLink[ID],
                        fact_id_5000: payload.spending_id
                    };
                }
            });
            
            return {
                ...state,
                ALL: updatedAllLink,
                PURCHASES: updatedPurchasesLink
            };
            
        case "UPDATE_PURCHASES_UNLINK":
            const updatedAllUnlink = { ...state.ALL };
            const updatedPurchasesUnlink = { ...state.PURCHASES };
            
            payload.list.forEach( ID => {
                if (updatedAllUnlink[ID]) {
                    updatedAllUnlink[ID] = {
                        ...updatedAllUnlink[ID],
                        fact_id_5000: ""
                    };
                }
                if (updatedPurchasesUnlink[ID]) {
                    updatedPurchasesUnlink[ID] = {
                        ...updatedPurchasesUnlink[ID],
                        fact_id_5000: ""
                    };
                }
            });
            
            return {
                ...state,
                ALL: updatedAllUnlink,
                PURCHASES: updatedPurchasesUnlink
            };

        default:
            return state;
    }
    
}